import { formatMoney, type Summary as SummaryData } from '@closetly/core';

interface Props {
  summary: SummaryData;
  currency: string;
  onEditBudget: () => void;
  onShare: () => void;
}

export function Summary({ summary: s, currency, onEditBudget, onShare }: Props) {
  const fmt = (c: number) => formatMoney(c, currency);
  return (
    <section className="summary" aria-live="polite">
      <div>
        <div className="lbl">Alles auf der Liste kostet</div>
        <div className="total">{fmt(s.openCents)}</div>
      </div>
      <div className="count">
        {s.openCount} {s.openCount === 1 ? 'Teil' : 'Teile'}
      </div>
      <div className="rows">
        <span>
          Must-haves <b>{fmt(s.mustCents)}</b>
        </span>
        <span>
          Schon gekauft <b>{fmt(s.boughtCents)}</b>
        </span>
      </div>
      <div className="budget">
        {s.budget ? (
          <>
            <div
              className="bar"
              role="img"
              aria-label={`Gekauft ${fmt(s.boughtCents)} von ${fmt(s.budget.budgetCents)} Budget`}
            >
              <i className="b-bought" style={{ width: `${s.budget.boughtPct}%` }} />
              <i className="b-must" style={{ width: `${s.budget.mustPct}%` }} />
            </div>
            <p>
              {s.budget.message}{' '}
              <button type="button" className="linkbtn" onClick={onEditBudget}>
                Ändern
              </button>
            </p>
          </>
        ) : (
          <button type="button" className="linkbtn" onClick={onEditBudget}>
            Budget festlegen
          </button>
        )}
        <button type="button" className="linkbtn share-list" onClick={onShare}>
          Liste teilen
        </button>
      </div>
    </section>
  );
}
